import React from "react";
import {Button, Card, Stack, Typography} from "@mui/material";
import {BadgeOutlined, Policy, ViewWeek} from "@mui/icons-material";
import {Link} from "react-router-dom";
import {pageAuthorizedByPermission} from "../fragments/PageAuthorization";
import {permissions} from "../../global/Permissions";
import {translateFunction} from "../../localization/TranslationService";

const translate = translateFunction();

export const AuthorizationOverviewPage = pageAuthorizedByPermission(function () {
	return <>
		<Stack direction={"row"} justifyContent={"space-evenly"} style={{width: "100%"}}>
			<Card variant={"outlined"} style={{padding: "20px 10px", width: "150px", height: "180px"}}>
				<Stack justifyContent={"space-between"} style={{height: "100%"}}>
					<div style={{textAlign: "center"}}>
						<BadgeOutlined fontSize={"large"}/>
						<Typography>{translate("Policies")}</Typography>
					</div>
					<Stack direction={"row-reverse"}>
						<Button component={Link} to={"./policies"}>{translate("Open")}</Button>
					</Stack>
				</Stack>
			</Card>
			<Card variant={"outlined"} style={{padding: "20px 10px", width: "150px", height: "180px"}}>
				<Stack justifyContent={"space-between"} style={{height: "100%"}}>
					<div style={{textAlign: "center"}}>
						<Policy fontSize={"large"}/>
						<Typography>{translate("Policy Usages")}</Typography>
					</div>
					<Stack direction={"row-reverse"}>
						<Button component={Link} to={"./policyusages"}>{translate("Open")}</Button>
					</Stack>
				</Stack>
			</Card>
			<Card variant={"outlined"} style={{padding: "20px 10px", width: "150px", height: "180px"}}>
				<Stack justifyContent={"space-between"} style={{height: "100%"}}>
					<div style={{textAlign: "center"}}>
						<ViewWeek fontSize={"large"}/>
						<Typography>{translate("Deploy")}</Typography>
					</div>
					<Stack direction={"row-reverse"}>
						<Button component={Link} to={"./deploy"}>{translate("Open")}</Button>
					</Stack>
				</Stack>
			</Card>
		</Stack>
	</>;
}, [permissions.authorizationRead]);
